<template>
  <section :id="$options.name" class="rooms">
    <h2 class="rooms__title">Disponibilità</h2>
    <b-row class="rooms__wrap">
      <b-col xl="9" class="rooms__content">
        <div class="rooms__element" v-for="(room, room_index) in details.rooms" :key="_uid+'_room_'+room_index">
          <room
            v-if="room.products !== ''"
            :room="room"
            :class="is_selected(room.id) ? 'selected' : ''"
            @toggle-collapse="room_toggle_collapse"
          />
          <b-collapse
            class="rooms__collapse"
            :id="_uid + '_room_' + room.id"
          >
            <b-row class="rooms__collapse-row">
              <b-col xl="4" class="rooms__collapse-col">
                <room-summary :room="room" />
              </b-col>
              <b-col xs="12" xl="8">
                <b-row>
                  <b-col
                    md="12" class="rooms__product"
                    v-for="(product, product_index) in room.products"
                    :key="_uid+'_product_'+product_index"
                  >
                    <room-product
                      :class="is_selected(product.id) ? 'selected' : ''"
                      :product_info="{
                        room_index: room_index,
                        product_index: product_index,
                        product: product
                      }"
                    />
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-collapse>
        </div>
      </b-col>
      <b-col xl="3" class="rooms__resume">
        <div class="rooms__resume-wrap">
          <resume
            v-if="selected_solution.rooms && Object.keys(selected_solution.rooms).length"
            :pricing="resume.pricing"
          />
          <resume-cta :solution="selected_solution" />
        </div>
      </b-col>
    </b-row>
  </section>
</template>

<script>
import { mapState } from 'vuex'
import { subtract } from 'mathjs'
import Room from '@bookingv3/components/blocks/detail/room/room'
import RoomSummary from '@bookingv3/components/blocks/detail/room/room-summary'
import RoomProduct from '@bookingv3/components/blocks/detail/room/room-product'
import Resume from '@bookingv3/components/blocks/resume/resume'
import ResumeCta from '@bookingv3/components/blocks/detail/resume-cta'

export default {
  inheritAttrs: false,
  name: 'rooms',

  components: {
    'room': Room,
    'room-summary': RoomSummary,
    'room-product': RoomProduct,
    'resume': Resume,
    'resume-cta': ResumeCta,
  },

  props: {
    details: Object,
  },

  data() {
    return {
    }
  },

  provide() {
    return {
      details: this.details
    }
  },

  computed: {
    ...mapState({
      // stato del modulo livebkv3
      selected_solution: state => state.livebkv3.selected_solution
    }),

    // Genera l'estratto di recap, escludendo sempre le tasse di soggiorno dal live price
    resume() {
      if (this.selected_solution.rooms && Object.keys(this.selected_solution.rooms).length) {

        const solution = {...this.selected_solution},
              {pricing} = solution,
              {extra_charges} = pricing,
              {included} = extra_charges,
              tax_item = included.find(tax => tax.charge === 22),
              chargeable = tax_item ? included.filter(tax => tax.charge !== 22) : [...included],
              not_chargeable = tax_item ? [tax_item] : [],
              book_price = subtract(pricing.book, tax_item ? tax_item.total_amount : 0)

        // struttura dati per il blocco di recap
        return {
          pricing: {
            base: pricing.base,
            book: book_price,
            live_price: pricing.live_price_no_tax,
            extra_charges: {
              ...extra_charges,
              included: {chargeable, not_chargeable}
            }
          }
        }
      }
      return {}
    }
  },

  created() {
  },

  mounted() {
  },

  update() {
  },

  methods: {

    // Determina lo stile per camera/prodotto selezionato
    is_selected(id) {
      if (this.selected_solution.rooms && this.selected_solution.rooms.length) {
        return this.selected_solution.rooms.some(room =>
          // controlla se l'id è presente a livello di camera o nei prodotti associati ad essa
          room.id_room === id || Object.values(room.products).some(product => product.id === id)
        )
      }
      return false
    },

    // Emette il toggle dell'elemento collapse con rispettivo id
    room_toggle_collapse(room_id) {
      this.$root.$emit('bv::toggle::collapse', this._uid + '_room_' + room_id)
    }

  },
}
</script>

<style lang="scss" scoped>

  .rooms {
    @extend %section;
    @extend %section_margin;
    border-top: 0;

    %is_selected {
      background-color: #fafcff;
      border-color: $gray-300;
    }

    .selected {
      ::v-deep {
        .vb-card__wrap {
          @extend %is_selected;
        }
      }
    }

    &__title {
      @extend %section__title;
    }

    &__element {
      margin-bottom: $grid-gutter-width;
      position: relative;

      @include media-breakpoint-up(lg){
        position: static;
      }

      &:last-child {
        margin-bottom: 0;
      }
    }

    &__collapse {
      padding: 0 10px;

      @include media-breakpoint-up(xl){
        padding: 0;
      }

      &-row {
        margin-top: $grid-gutter-width/3;
        padding-bottom: $grid-gutter-width/3;

        @include media-breakpoint-up(xl){
          margin-top: $grid-gutter-width;
          padding-bottom: $grid-gutter-width;
        }
      }

      &-col {
        display: none;

        @include media-breakpoint-up(xl){
          display: block;
        }
      }
    }

    &__info {
      border-radius: 10px;
      padding: 20px;
      background-color: #fafcff;
      font-size: $font-size-md;
      color: $dark;
      width: 100%;

      @include media-breakpoint-up(xl){
        margin-top: $grid-gutter-width;
      }
    }

    &__resume {
      margin-top: $grid-gutter-width*2;

      @include media-breakpoint-up(xl){
        margin-top: 0;
      }

      &-wrap {
        background-color: $white;
        border-radius: 10px;
        padding: 15px;
        overflow: hidden;

        @include media-breakpoint-up(xl){
          background-color: transparent;
          border-radius: 0;
          padding: 0;
          position: sticky;
          top: $grid-gutter-width/2;
          overflow: auto;
        }

        ::v-deep {
          .custom-link {
            a {
              display: block;
            }
          }
        }
      }
    }

    &__product {
      margin-bottom: $grid-gutter-width/2;

      .selected {
        @extend %is_selected;
      }

      &:last-child {
        margin-bottom: 0;
      }
    }
  }

</style>